export const ORDER_SALE_TYPE_PROMOCODE = 'promocode'
export const ORDER_SALE_TYPE_LOYMAX = 'loymax'
